const prettyId = (uuid) => uuid?.slice(0, 8);

export default prettyId;
